export interface CmsBlock {
  id: string;
  type: 'header' | 'paragraph' | 'image' | 'list' | 'callout' | 'table' | 'delimiter' | 'code' | 'columns';
  data: Record<string, any>;
}

export interface CmsPage {
  id?: number | null;
  slug: string;
  pageName: string;
  body: CmsBlock[];
  metaDescription?: string;
  navParentPageId?: number | null;
  isMainMenuItem?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface SiteLayoutData {
  header: {
    siteTitle: string;
    tagline?: string;
  };
  footer: {
    copyrightText: string;
    aboutText?: string;
    links?: { label: string; url: string }[];
  };
  holidayGreeting?: string;
}

export interface CollectionItem {
  id: number | string;
  name?: string;
  word?: string;
  title?: string;
  description?: string;
  definition?: string;
  price?: number;
  defense?: number;
  stat?: string;
  bonus?: number;
  hit_points?: number;
  credits?: number;
  cost?: number;
  max?: number;
  tags?: string[];
  [key: string]: any;
}

export interface CollectionResult {
  collection: string;
  title: string;
  items: CollectionItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface MapHotspot {
  slug: string;
  title: string;
  icon: string;
  x: number;
  y: number;
  eyebrow?: string;
  description?: string;
  chips?: string[];
}

export interface MapData {
  slug: string;
  title: string;
  shortTitle?: string;
  eyebrow?: string;
  summary?: string;
  description?: string;
  image: {
    src: string;
    alt: string;
  };
  chips?: string[];
  minScale?: number;
  maxScale?: number;
  initialScale?: number;
  hotspots?: MapHotspot[];
  legend?: { label: string; icon: string }[];
}

export const THEMES = [
  { id: 'cosmic-universe', name: 'Cosmic Universe', icon: '🌌' },
  { id: 'haunted-harvest', name: 'Haunted Harvest', icon: '🎃' },
  { id: 'cupcake', name: 'Cupcake Dream', icon: '🧁' },
  { id: 'hearts', name: 'Sweet Hearts', icon: '💖' },
  { id: 'paper', name: 'Vintage Paper', icon: '📜' },
  { id: 'rainy-day', name: 'Rainy Day', icon: '🌧️' },
  { id: 'strawberry-garden', name: 'Strawberry Garden', icon: '🍓' },
  { id: 'aurora-noctis', name: 'Aurora Noctis', icon: '✨' },
  { id: 'asymmetrical-dark', name: 'Asymmetrical Dark', icon: '🌑' },
  { id: 'signal-noir', name: 'Signal Noir', icon: '📻' },
  { id: 'cyberpunk', name: 'Neon Cyberpunk', icon: '⚡' },
  { id: 'dark-rainbow', name: 'Dark Rainbow', icon: '🌈' },
  { id: 'light-rainbow', name: 'Light Rainbow', icon: '☀️' },
] as const;

export type ThemeId = typeof THEMES[number]['id'];
